<template>
  <intro-box>
    <div class="task-code-container home-container" v-if="!codeSet">
      <ul class="errors">
        <li v-for="error in errors" :key="error">{{ error }}</li>
      </ul>
      <input v-model="code" class="home-input" placeholder="Skriv in din kod"><br />
      <a href="#" class="home-button button is-primary is-rounded" v-on:click="submit">Fortsätt</a>
    </div>

    <div class="task-username-container home-container" v-else>
      <ul class="errors">
        <li v-for="error in errors" :key="error">{{ error }}</li>
      </ul>
      <input class="home-input" v-model="username" placeholder="Ange namn"><br />
      <a href="#" class="home-button button is-primary is-rounded" v-on:click="submit_username">Fortsätt</a>
    </div>
  </intro-box>
</template>

<script>
import IntroBox from '@/components/elements/IntroBox.vue'
const SITE_URL = process.env.SITE_URL

export default {
  name: 'home',
  data () {
    return {
      code: "",
      username: "",
      errors: []
    }
  },
  components: {
    IntroBox
  },
  computed: {
    taskCode() {
      return this.$store.state.taskCode
    },
    codeSet() {
      if(this.$store.state.taskCode){
        return true
      } else {
        return false
      }
    },
    slug() {
      return this.$store.state.slug
    },
    isCompleted() {
      return this.$store.state.isCompleted
    }
  },
  methods: {
    submit() {
      if(this.code != "") {
        this.$store.dispatch('validateTaskCode', this.code)
          .then(() => {
            if(!this.taskCode){
              this.errors.push('Oops! Felaktig kod')
            } else {
              this.errors = [];
            }
          })
      }
    },
    submit_username() {
      this.errors = []
      if(this.username == "") {

      } else if(this.username.indexOf("@") > 0) {
        this.errors.push('Ogiltigt namn, "@" är inte tillåtet.')
      } else if(this.username.length < 2) {
        this.errors.push('Ogiltigt namn, inte tillräckligt länge.')
      } else {
        this.$store.dispatch('submitUsername', this.username)
          .then(() => {
            if(this.slug){
              if(this.isCompleted == "completed") {
                this.$router.push({path: `/assignment/${this.slug}/confirmation`})
              } else {
                this.$router.push({path: `/assignment/${this.slug}`})
              }
            } else {
              this.errors.push('Ogiltigt namn.')
            }
          })
      }
    }
  },
  mounted: function() {
    let slug = this.$route.params.assignment
    let that = this
    if(slug) {
      this.$store.dispatch('validateTaskCode', slug)
        .then(() => {
          /*if (!that.assignment) {
            this.$store.dispatch('loadAssignment', slug)
            .then(() => {
              if (that.assignment.status == 'completed') {
                that.$router.push(`/assignment/${that.assignment.slug}/confirmation`)
              }
            })
          } else {
            if (that.assignment.status == 'completed') {
              that.$router.push(`/assignment/${that.assignment.slug}/confirmation`)
            }
          }*/
          // go to username step
          if (that.assignment.status == 'completed') {
            //that.$router.push(`/assignment/${that.assignment.slug}/confirmation`)
          }
        })
    }

  }
}
</script>
<style>
  body {
    overflow: hidden;
  }

  ul.errors {
    list-style-type: none;
    margin-left: 0;
  }

  .button {
    margin-top: 25px;
    bottom: 0;
  }

  .home-container {
    width: 50%;
    margin: 0 auto;
    text-align: center;
  }

  .home-input {
    padding: 0.8em 1.5em !important;
    height: auto;
    font-size: 16px;
    line-height: 1.5;
    padding-left: 1em;
    padding-right: 1em;
  }

</style>
